var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOrangeTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 13.2412C8.80363 13.2412 8.6123 13.291 8.44957 13.3842C8.28683 13.4774 8.15999 13.6099 8.08509 13.7649C8.01019 13.9198 7.9906 14.0904 8.02878 14.2549C8.06696 14.4195 8.16121 14.5706 8.29961 14.6892C8.438 14.8079 8.61433 14.8886 8.80629 14.9214C8.99825 14.9541 9.19722 14.9373 9.37805 14.8731C9.55887 14.8089 9.71342 14.7002 9.82216 14.5607C9.93089 14.4212 9.98893 14.2572 9.98893 14.0894C9.98893 13.8645 9.88467 13.6487 9.69909 13.4897C9.51351 13.3306 9.2618 13.2412 8.99935 13.2412ZM8.33963 7.021H9.65907V12.1103H8.33963V7.021Z",
    fill: "#F9CB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3511 16.9168H1.64827C1.55116 16.9168 1.45569 16.8908 1.37107 16.8414C1.28645 16.792 1.21552 16.7208 1.16512 16.6347C1.11472 16.5486 1.08655 16.4505 1.08332 16.3499C1.08009 16.2492 1.10191 16.1494 1.14668 16.06L8.49808 1.39913C8.54585 1.30398 8.61788 1.22423 8.70632 1.16858C8.79476 1.11292 8.89622 1.0835 8.99967 1.0835C9.10312 1.0835 9.20459 1.11292 9.29303 1.16858C9.38147 1.22423 9.4535 1.30398 9.50127 1.39913L16.8527 16.06C16.8974 16.1494 16.9193 16.2492 16.916 16.3499C16.9128 16.4505 16.8846 16.5486 16.8342 16.6347C16.7838 16.7208 16.7129 16.792 16.6283 16.8414C16.5437 16.8908 16.4482 16.9168 16.3511 16.9168ZM2.58134 15.744H15.418L15.4186 15.7422L9.00081 2.94205H8.99854L2.58021 15.7422L2.58134 15.744Z",
    fill: "#F9CB00",
    stroke: "#F9CB00",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrangeTriangle);
export default __webpack_public_path__ + "static/media/warning-orange-triangle.9107da1136e1bb16d03447879cee0f75.svg";
export { ForwardRef as ReactComponent };